import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { EquipmentHistoricalDataComponent } from 'app/modules/equipment-registration/component/equipment-historical-data/equipment-historical-data.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private equipmentServices: EquipRegistrationServices
  ) {
  }

  ngOnInit() { }

  viewEquipment(equipmentReg: any) {
    let equipmentRegRoute = this.handleEquipRegRoute(equipmentReg)

     this.equipmentServices.viewEquipment = equipmentRegRoute; // 👈 triggers the setter

    // const route = `/data-management/eReg/equipment-registration/${equipmentRegRoute}`;
    // this.router.navigate([route]);
  }

  viewEquipmentHistoricalData(equipment: any) {
    let { valveType, valveName } = this.getValveType(equipment.equipmentName)

    const dialogRef = this.dialog.open(EquipmentHistoricalDataComponent, {
      data: {
        valveType: valveType,
        valveName: valveName,
        wellStringId: equipment.wellStringId
      },
      width: "100%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (equipment?.wellStringId) {
        this.equipmentServices.getEquipmentRegistration(equipment.wellStringId).subscribe();
      }
    });
  }

  handleFormatDate(dateString: string, withTime: boolean = true) {
    return handleFormatDate(dateString, withTime)
  }

  private handleEquipRegRoute(equipmentReg) {
    let route: string;

    switch (equipmentReg.equipmentName) {
      case 'Xmas Tree':
        route = 'xmastree'
        break;
      case 'Crown Valve':
        route = 'cv'
        break;
      case 'Lower Master Valve':
        route = 'lmv'
        break;
      case 'Kill Wing Valve':
      case 'King Wing Valve' :
        route = 'kwv'
        break;
      case 'Wing Valve':
        route = 'wgv'
        break;
      case 'Surface Safety Valve':
        route = 'ssv'
        break;
      case 'Annulus Valve A':
        route = 'annulus-valve-a'
        break;
      case 'Annulus Valve B':
        route = 'annulus-valve-b'
        break;
      case 'Annulus Valve C':
        route = 'annulus-valve-c'
        break;
      case 'Annulus Valve D':
        route = 'annulus-valve-d'
        break;
      case 'Annulus Valve D':
        route = 'annulus-valve-d'
        break;
      case 'TR-SSSV':
        route = 'trscssv-wrsv/trscssv'
        break;
      case 'WRSV':
        route = 'trscssv-wrsv/wrsv'
        break;
      default:
        route = ''
        break;
    }

    return route
  }

  private getValveType(equipmentName) {
    let valveType: string;
    let valveName: string;


    switch (equipmentName) {
      case 'Xmas Tree':
        valveType = 'XMT'
        valveName = 'Xmas Tree'
        break;

      case 'Crown Valve':
        valveType = 'CV'
        valveName = 'Crown Valve'
        break;

      case 'Lower Master Valve':
        valveType = 'LMV'
        valveName = 'Lower Master Valve'
        break;

      case 'King Wing Valve':
      case 'Kill Wing Valve':

        valveType = 'KWV'
        valveName = 'King Wing Valve'
        break;

      case 'Wing Valve':
        valveType = 'WV'
        valveName = 'Wing Valve'
        break;

      case 'Surface Safety Valve':
        valveType = 'SSV'
        valveName = 'Surface Safety Valve'
        break;

      case 'Annulus Valve A':
        valveType = 'PCV'
        valveName = 'Annulus Valve A'
        break;

      case 'Annulus Valve B':
        valveType = 'ICV'
        valveName = 'Annulus Valve B'
        break;

      case 'Annulus Valve C':
        valveType = 'SCV'
        valveName = 'Annulus Valve C'
        break;

      case 'Annulus Valve D':
        valveType = 'CCV'
        valveName = 'Annulus Valve D'
        break;

      case 'TR-SSSV':
        valveType = 'TRSV'
        valveName = 'TR-SSSV'
        break;

      case 'WRSV':
        valveType = 'WRSV'
        valveName = 'WRSV'
        break;

      default:
        valveType = ''
        valveName = ''
        break;
    }
    return { valveType, valveName }
  }
}
